export default {
  SOLID: 'solid',
  GRADIENT: 'gradient',
};
